"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regexpExec = regexpExec;
exports.default = void 0;

var _regexp = require("../../internal/regexp");

var _string = require("../../internal/string");

function* regexpExec(str, regexp) {
  if (typeof regexp === 'string') {
    regexp = new RegExp(regexp, 'g');
  }

  if (!regexp.sticky && !regexp.global) {
    regexp = (0, _regexp.cloneRegexp)(regexp, {
      global: true
    });
  }

  let match;

  while ((match = regexp.exec(str)) !== null) {
    yield match;
  }
}

var _default = (0, _string.stringCurry)(regexpExec, {
  validateArgs([regexp]) {
    if (!(0, _regexp.isRegExp)(regexp)) {
      throw new TypeError('regexpExec: the first argument can be a string or a regular expression');
    }
  }

});

exports.default = _default;